'use client';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from '@eliadmin/core/src/components/ui/sheet';

import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import Link from '@eliadmin/core/src/components/link';
import { Button } from '../ui/button';

export type MobileSidebarProps = {
  className?: {
    trigger?: string;
    content?: string;
    firstSeparator?: string;
    menuList?: string;
    menuLink?: string;
    menuGroup?: string;
    menuSeparator?: string;
    buttonWrapper?: string;
    button?: string;
    iconsWrapper?: string;
    icon?: string;
  };
  side?: 'right' | 'left' | 'bottom' | 'top';
  firstSeparator?: boolean;
  menu?: {
    type: 'page';
    name: string;
    path?: string;
  }[];
  menuArrow?: boolean;
  menuSeparator?: boolean;
  categories?: CategoriesEntity[];
};

const MobileSidebar = (props: MobileSidebarProps) => {
  return (
    <>
      <Sheet>
        <SheetTrigger
          aria-label="Otvoriť menu"
          className={cn('text-primary', 'ea-mobile-sidebar__trigger', props.className?.trigger)}
        >
          {HEADER_CONFIG?.sidebar?.triggerIcon}
        </SheetTrigger>
        <SheetContent
          overlayClassName="hidden bg-transparent"
          side={props.side}
          className={cn(
            'top-[81px] w-full max-w-[640px] justify-between overflow-auto p-0 sm:top-[89px] lg:top-[97px]',
            'ea-mobile-sidebar__content',
            props.className?.content,
          )}
          closeIcon={{
            wrapper: 'right-4 top-4',
            icon: 'text-primary h-6 w-6 font-bold',
          }}
        >
          <div className="flex w-full flex-col items-center justify-center gap-6 px-4 pt-8">
            {props.menu?.map(field => (
              <SheetClose asChild key={field.name} className="text-center text-base font-medium">
                <Link prefetch={false} href={getSafeHref(field?.path ?? '#')}>
                  {field.name}
                </Link>
              </SheetClose>
            ))}
            <SheetClose asChild className="w-full">
              <Button asChild>
                <Link prefetch={false} href={'/pre-uchadzaca'}>
                  Pracovné ponuky SMS-kou
                </Link>
              </Button>
            </SheetClose>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default MobileSidebar;
